
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/proptrading",
      function () {
        return require("private-next-pages/proptrading/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/proptrading"])
      });
    }
  